import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const revealRef = useScrollReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section ref={revealRef} aria-labelledby="faq-nadpis" className="py-20 md:py-32 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-66" data-mp="1ntzxj7nl3p0s">
      <div className="reveal text-center mb-12 md:mb-16" data-id="element-67" data-mp="2bmgpc9x4ivda">
        <p className="text-xs font-semibold tracking-[0.2em] text-apple-gray uppercase mb-4" data-id="element-68" data-mp="2fkwas9dk3vol">FAQ</p>
        <h2 id="faq-nadpis" className="text-3xl sm:text-4xl md:text-6xl font-extrabold tracking-tight text-apple-black mb-5" data-id="element-69" data-mp="21thrs2jnfuhj">
          Často kladené otázky
        </h2>
        <p className="text-lg md:text-xl text-apple-gray" data-id="element-70" data-mp="2ui6ta2oma1tt">Všetko o technológiách a spolupráci.</p>
      </div>

      <div className="reveal space-y-3" data-id="element-71" data-mp="2zaq6uznb0wym">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        const buttonId = `faq-otazka-${index}`;
        const panelId = `faq-odpoved-${index}`;
        return <div key={faq.question} className={`border rounded-2xl bg-white overflow-hidden transition-colors duration-200 ${isOpen ? 'border-apple-blue/40 shadow-sm' : 'border-gray-200'}`} data-id="element-72" data-mp="25fklfuvcgxp2" data-mpi={index}>
              <h3 data-id="element-73" data-mp="2fc75wijrdmqk">
                <button id={buttonId} type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="w-full min-h-[56px] px-5 md:px-8 py-5 flex justify-between items-center gap-4 text-left rounded-2xl" data-id="element-74" data-mp="2ffuxhc5n7z2n">
                  <span className="text-base md:text-lg font-bold text-apple-black" data-id="element-75" data-mp="u0nsi9w1hocf">{faq.question}</span>
                  <ChevronDownIcon className={`w-5 h-5 text-apple-blue flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-76" data-mp="p3fd2h29zyev" />
                </button>
              </h3>
              <div id={panelId} role="region" aria-labelledby={buttonId} hidden={!isOpen} className="px-5 md:px-8 pb-6" data-id="element-77" data-mp="2z0yl6hchno6b">
                <p className="text-apple-gray leading-relaxed" data-id="element-78" data-mp="3826c2ecodmqd">{faq.answer}</p>
              </div>
            </div>;
      })}
      </div>
    </section>;
}